import InventoryManagementGrid from './InventoryManagementGrid';

export default InventoryManagementGrid;



// WEBPACK FOOTER //
// ./src/components/grids/InventoryManagementGrid/index.jsx